// gatsby-browser.js
import React from 'react';
import './src/styles/global.css';
import PageTransition from './src/components/PageTransition';

export const wrapPageElement = ({ element, props }) => {
  return <PageTransition locationKey={props.location.key}>{element}</PageTransition>;
};

export const onClientEntry = () => {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
};

export const shouldUpdateScroll = () => false;
